import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";
import firebaseConfig from "./firebase_config.js";

export const app = initializeApp(firebaseConfig);

export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js", { scope: "/" })
      .then((registration) => console.log("Service Worker registrado:", registration))
      .catch((error) => console.error("Erro no SW:", error));
  }
};

export const initPushNotifications = (setMessaging) => {
  if ("PushManager" in window) {
    const messagingInstance = getMessaging(app);
    setMessaging(messagingInstance);

    onMessage(messagingInstance, (remoteMessage) => {
      console.log("remoteMessage", remoteMessage);
    });

    getToken(messagingInstance)
      .then((token) => console.log("Token do dispositivo:", token))
      .catch((error) => console.warn("Erro ao obter token push:", error));
  } else {
    console.log("Push API não suportada neste navegador.");
  }
};

export const checkMaintenanceStatus = async () => {
  try {
    const remoteConfig = getRemoteConfig(app);
    remoteConfig.settings = { minimumFetchIntervalMillis: 3600000 };
    await fetchAndActivate(remoteConfig);
    const raw = getValue(remoteConfig, "appConfig").asString();
    if (raw) {
      const parsed = JSON.parse(raw);
      return !!parsed?.MANUT_STATUS;
    }
  } catch (err) {
    console.error("Remote Config falhou:", err);
  }
  return false;
};